exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._23kpZqDCzJUHe-{background:#eb5a46;border-radius:3px;padding:16px;font-size:14px;line-height:20px;color:#fff;text-align:left;margin-bottom:8px}", ""]);

// exports
exports.locals = {
	"error": "_23kpZqDCzJUHe-"
};